// redux/reducers/blogReducer.js

  const initialState = {
    loading: false,
    newPass: false,
    error: false,
    blogListing:[],
    totalBlog:0,
    blogDetail:null
  };
  
  const blogReducer = (state = initialState, action) => {
    console.log("make reducers------", state,action);
   switch (action.type) {
     case "ADD_BLOG_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_BLOG_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_BLOG_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_BLOG_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_BLOG_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_BLOG_REQUEST_SUCCESS":
        return {
          ...state,
          blogListing: action.payload,
          totalBlog: action.total,

          loading:false,
        };

      case "GOT_BLOG_DETAIL":  
      return {
        ...state,
        blogDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default blogReducer;
  